import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import Header from './header/Header';

const GridMain = styled(Grid)(() => ({
  flexDirection: 'row',
  display: 'flex',
  alignItems: 'stretch',
  flex: 1,
}));

const BarStyled = styled(Grid)(({ theme }) => ({
  width: 50,
  backgroundColor: theme.palette.primary.main,
}));

const ContentStyled = styled(Grid)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}));

export default function DefaultView({ children }: { children: JSX.Element }) {
  return (
    <GridMain className='grid-main'>
      <BarStyled></BarStyled>
      <ContentStyled>
        <Header />
        {children}
      </ContentStyled>
    </GridMain>
  );
}
